<script setup lang="ts">

const widgetToken = '92c722978e7e4c329d645b67ecd18fdc';


const props = defineProps<{
	price: number | string
}>()

</script>

<template>
	<div class="">
	<anyday-price-widget
		theme="outline"
		currency="DKK"
		price-selector=".js-product-price"
		:price="price"
		price-format-locale="da-DK"
		locale="da-DK"
		:token="widgetToken"
		fully-clickable="true"
		container-breakpoint="350"
		debug="info" />
	</div>
</template>
